import IUseClass = ZoneIQCalibration.IUseClass;

const useClassOptions: IUseClass[] = [
    {
        Id: 1,
        Label: 'Primary',
        Abbreviation: 'P'
    },
    {
        Id: 2,
        Label: 'Accessory',
        Abbreviation: 'A'
    }
];

export default useClassOptions;
